module.exports = __webpack_public_path__ + "img/empty.b305394c.svg";